import { Directive, ElementRef, Input } from '@angular/core';
import { User } from '../models/user';

@Directive({
  selector: '[appPortal]',
})
export class PortalDirective {
  @Input() object!: string;
  @Input() action!: string;

  private companyDisabledDeleteList = [
    'company',
    'tariff_code',
    'provider',
    'medical_condition',
    'task',
  ];
  private companyDisabledEditList = [
    'grade',
    'provider',
    'medical_condition',
    'task',
  ];

  private providerDisabledDeleteList = ['company'];
  private providerDisabledEditList = [];

  constructor(private elementRef: ElementRef) {}

  ngOnInit() {
    const user = new User(JSON.parse(localStorage.getItem('user')!));
    if (user.affiliation?.toLocaleLowerCase() == 'admin') {
      // this.elementRef.nativeElement.style.display = 'none';
      return;
    } else if (user.affiliation?.toLocaleLowerCase() == 'company') {
      if (
        this.action == 'delete' &&
        this.companyDisabledDeleteList.find((el) => el == this.object)
      ) {
        this.elementRef.nativeElement.style.display = 'none';
      }
      if (
        this.action == 'edit' &&
        this.companyDisabledEditList.find((el) => el == this.object)
      ) {
        this.elementRef.nativeElement.style.display = 'none';
      }
      return;
    } else if (user.affiliation?.toLocaleLowerCase() == 'company') {
      if (
        this.action == 'delete' &&
        this.companyDisabledDeleteList.find((el) => el == this.object)
      ) {
        this.elementRef.nativeElement.style.display = 'none';
      }
      if (
        this.action == 'edit' &&
        this.companyDisabledEditList.find((el) => el == this.object)
      ) {
        this.elementRef.nativeElement.style.display = 'none';
      }
      return;
    } else if (user.affiliation?.toLocaleLowerCase() == 'provider') {
      if (
        this.action == 'delete' &&
        this.providerDisabledDeleteList.find((el) => el == this.object)
      ) {
        this.elementRef.nativeElement.style.display = 'none';
      }
      if (
        this.action == 'edit' &&
        this.providerDisabledEditList.find((el) => el == this.object)
      ) {
        this.elementRef.nativeElement.style.display = 'none';
      }
      return;
    }
  }
}
